export default "__VITE_ASSET__7465f486__"